<div class="row" *ngIf="isBasica || isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Peso de palha na carga (kg)
                                </mat-label>
                                <input matInput id="txtPeso_palha_carga_kg" #txtPeso_palha_carga_kg maxlength="10"
                                    formControlName="Peso_palha_carga_kg" readonly class="InputBlockColor" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_palha_carga_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_palha_carga_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Peso líquido carga com umidade (kg)
                                </mat-label>
                                <input matInput id="txtPeso_liquido_carga_umidade_kg" #txtPeso_liquido_carga_umidade_kg
                                    maxlength="10" formControlName="Peso_liquido_carga_umidade_kg"
                                    class="InputBlockColor" readonly currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_liquido_carga_umidade_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_liquido_carga_umidade_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Perda no processo (kg)
                                </mat-label>
                                <input matInput id="txtPerda_processo_kg" #txtPerda_processo_kg maxlength="10"
                                    formControlName="Perda_processo_kg" class="InputBlockColor" readonly currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPerda_processo_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Perda_processo_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Peso espigas inteiras perdidas (kg)
                                </mat-label>
                                <input matInput id="txtPeso_espigas_inteiras_perdidas_kg"
                                    #txtPeso_espigas_inteiras_perdidas_kg maxlength="10"
                                    formControlName="Peso_espigas_inteiras_perdidas_kg" class="InputBlockColor" readonly
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_espigas_inteiras_perdidas_kg.value.length}} /
                                    10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_espigas_inteiras_perdidas_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote DS</mat-label>
                                <input matInput id="txtLoteDS" #txtLoteDS maxlength="10" formControlName="lote_ds">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteDsPet}}</mat-hint>
                                <mat-hint align="end">{{txtLoteDS.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_ds)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Numero Caixa
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtNumCaixa" #txtNumCaixa maxlength="5"
                                    formControlName="numero_caixa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly
                                    class="InputBlockColor">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inicio Debulha Data
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtInicioDebulhaData" #txtInicioDebulhaData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="inicio_debulha_data" (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtInicioDebulhaData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_debulha_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inicio Debulha Hora
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtInicioDebulhaHora" #txtInicioDebulhaHora maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="inicio_debulha_hora" mask="Hh:m0"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtInicioDebulhaHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_debulha_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Debulha (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtUmidadeDebulha" #txtUmidadeDebulha maxlength="8"
                                    formControlName="umidade_debulha_prc" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2, suffix: '%' }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Numero de bag iniciado
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtBagIniciado" #txtBagIniciado maxlength="5"
                                    formControlName="numero_bag_iniciado" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Numero de bag finalizado
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtBagFInalizado" #txtBagFInalizado maxlength="5"
                                    formControlName="numero_bag_finalizado" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso bruto do bag finalizado (kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoBrutoBagFinalizado" #txtPesoBrutoBagFinalizado maxlength="6"
                                    formControlName="peso_bruto_bag_finalizado" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso líquido do bag finalizado (kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoLiquidoBagFinalizado" #txtPesoLiquidoBagFinalizado
                                    maxlength="6" formControlName="peso_liquido_bag_finalizado" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote PA
                                    <span *ngIf="isG0" class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtLotePA" #txtLotePA maxlength="10" formControlName="lote_pa">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteDsPet}}</mat-hint>
                                <mat-hint align="end">{{txtLotePA.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_pa)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso PA Bruto
                                    <span *ngIf="isG0" class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoPaBruto" #txtPesoPaBruto maxlength="6"
                                    formControlName="peso_pa_bruto" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso PA Liquido
                                    <span *ngIf="isG0" class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoPaLiquido" #txtPesoPaLiquido maxlength="6"
                                    formControlName="peso_pa_liquido" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Descarte PA
                                    <span *ngIf="isG0" class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDescartePA" #txtDescartePA maxlength="6"
                                    formControlName="descarte_pa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de Sacos
                                    <span *ngIf="isG0" class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDescartePA" #txtDescartePA maxlength="6"
                                    formControlName="numero_sacos" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Motivo de Parada</mat-label>
                                <textarea matInput id="txtMotivoParada" #txtMotivoParada maxlength="255"
                                    formControlName="motivo_parada_debulha"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtMotivoParada.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.motivo_parada_debulha)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de parada hora
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtTempoParadaDebulha" #txtTempoParadaDebulha maxlength="5"
                                    [dropSpecialCharacters]="true" formControlName="tempo_parada_debulha_hora"
                                    mask="Hh:m0" (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtTempoParadaDebulha.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_parada_debulha_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fim Debulha Data
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtFimDebulhaData" #txtFimDebulhaData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000" formControlName="fim_debulha_data"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtFimDebulhaData.value.length}} / 10</mat-hint>
                                <mat-error>Data Fim não pode ser anterior a Data Inicio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fim Debulha Hora
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtFimDebulhaHora" #txtFimDebulhaHora maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="fim_debulha_hora" mask="Hh:m0"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtFimDebulhaHora.value.length}} / 5</mat-hint>
                                <mat-error>Data Fim não pode ser anterior a Data Inicio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>